module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/folder-980e276ee868a06084234f4a86f402d5.svg";